import React from 'react';

import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';

export default function BookingCancelledToggle(props) {
  return (
    <Box id="BookingCancelledToggle">
      <FormControl component="fieldset">
        <FormLabel component="legend">Should the booking be cancelled?</FormLabel>
        <RadioGroup
          row
          name="mark_cancelled"
          value={props.mark_cancelled == null ? '' : Number(props.mark_cancelled).toString()}
          onChange={props.handleFlagChange}
        >
          <FormControlLabel
            value="1"
            control={<Radio inputProps={{ className: 'T-mark-cancelled-yes', required: true }} />}
            label="Yes"
          />

          <FormControlLabel
            value="0"
            control={<Radio inputProps={{ className: 'T-mark-cancelled-no' }} />}
            label="No"
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
}
